import React, { useEffect} from 'react';
import { AutoCenter,Image } from 'antd-mobile'
// import { request } from '@/utils'

import { useParams,useNavigate } from "react-router-dom";
import { request } from '@/utils'
import './index.scss'
// const IconFont = createFromIconfontCN({
//   scriptUrl: '//at.alicdn.com/t/c/font_4335219_nhipwl2o8u8.js',
// });

const TOKENKEY = 'cx315_token'

const Al = () => {
  const navigate = useNavigate()
 const params = useParams()
   useEffect(() => {
          async function getau() {
              const resp = await request.post('/v2/p_type_2026', params)
              if (resp.return_code === "success") {
                  localStorage.setItem(TOKENKEY, JSON.stringify(resp))
                   navigate('/Al')
  
              }


  
          }
          getau()
  
      }, [params,navigate])

  ///请求 返回json  写入

  return <><AutoCenter>
  
  <Image
            src='sy.png'
            width={228}
            height={228}
            fit='cover'
            style={{ borderRadius: 114,marginTop:'189px' }}
          />
  </AutoCenter>
   

  </>
}

export default Al;